<template>
  <asc-dialog
    text="Visualize Fault Code"
    :width="800"
    :show-dialog="showDialog"
    :on-close="onClose"
  >
    <asc-spinner-wrapper :loading="loading">
      <div class="asc-visualize-fault-code-dialog">
        <div class="asc-visualize-fault-code-dialog--filters">
          <asc-text-field-input
            v-model="getMessageCode"
            label="Message Code"
            :disabled="true"
          ></asc-text-field-input>
          <asc-text-field-input
            v-model="getTailNumber"
            label="Tail"
            :disabled="true"
          ></asc-text-field-input>
          <asc-text-field-input
            :value="getDateString"
            label="Date Range"
            :disabled="true"
          ></asc-text-field-input>
        </div>
        <div class="asc-visualize-fault-code-dialog--graph">
          <asc-header
            class="asc-visualize-fault-code-dialog--graph-title"
            uppercase
            size="h4"
            :value="getGraphTitle"
          />
          <asc-visualize-fault-code-graph
            :tail-number="getTailNumber"
            :data="getCounts"
            :message-code="getMessageCode"
          >
          </asc-visualize-fault-code-graph>
        </div>
      </div>
    </asc-spinner-wrapper>
  </asc-dialog>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import AscVisualizeFaultCodeGraph from './AscVisualizeFaultCodeGraph'
import AscHeader from '@/components/atoms/AscHeader'

export default {
  name: 'AscVisualizeFaultCodeDialog',

  components: {
    AscDialog,
    AscSpinnerWrapper,
    AscTextFieldInput,
    AscVisualizeFaultCodeGraph,
    AscHeader,
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    getMessageCode() {
      return this.data?.messageCode || 'N/A'
    },

    getTailNumber() {
      return this.data?.tailNumber || 'N/A'
    },

    getCounts() {
      return this.data?.counts || []
    },

    getGraphTitle() {
      const tailNumber = this.getTailNumber
      return `Fault message count for ${tailNumber} over past ${this.getDateNumberString} days`
    },

    getDateString() {
      const timeline = this.data?.timelineText || '1w'
      switch (timeline) {
        case '1w':
          return 'Last 7 Days'
        case '2w':
          return 'Last 14 Days'
        case '1m':
          return 'Last 30 Days'
        case '3m':
          return 'Last 90 Days'
        case '6m':
          return 'Last 180 Days'
        case '1y':
          return 'Last 365 Days'
        default:
          return 'Last 30 Days'
      }
    },

    getDateNumberString() {
      const timeline = this.data?.timelineText || '1w'
      switch (timeline) {
        case '1w':
          return '7'
        case '2w':
          return '14'
        case '1m':
          return '30'
        case '3m':
          return '90'
        case '6m':
          return '180'
        case '1y':
          return '365'
        default:
          return '30'
      }
    },
  },
}
</script>

<style lang="scss">
.asc-visualize-fault-code-dialog {
  &--filters {
    margin-bottom: 20px;
    display: flex;

    input[type='text'] {
      color: $primary-black;
    }

    .v-text-field > .v-input__control > .v-input__slot::before {
      border-style: none !important;
    }
  }

  &--graph-title {
    & .asc-header--h4 {
      text-align: center;
      font-size: 14px !important;
      font-weight: 500 !important;
      line-height: 18px !important;
      letter-spacing: 1px !important;
    }
  }
}
</style>
